import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product-recent",
  "use": "icon-product-recent-usage",
  "viewBox": "0 0 14.537 14.539",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.537 14.539\" id=\"icon-product-recent\">\n  <path id=\"icon-product-recent_iconmonstr-time-17\" d=\"M114.437,107.145a7.269,7.269,0,0,1-14.537,0h1.212a6.077,6.077,0,1,0,1.751-4.251l1.254,1.245-4.218.819.791-4.251,1.321,1.321a7.264,7.264,0,0,1,12.426,5.117Zm-7.872-3.631v4.843H110.8v-1.212h-3.03v-3.631Z\" transform=\"translate(-99.9 -99.872)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol